import GeneratedSalesServiceApi from "./generated/GeneratedSalesServiceApi"

class SalesServiceApi extends GeneratedSalesServiceApi {

}

export const salesServiceApi = new SalesServiceApi()
